@if (data.isLoading()) {
  <div class="flex flex-row w-full justify-between items-center mb-8">
    <h1 class="font-bold mb-0">{{ { key: 'isLoading' } | i18n }}</h1>
  </div>
  <div class="flex justify-center items-center h-64">
    <app-loading [noWhitespace]="true"></app-loading>
  </div>
} @else if (data.error()) {
  <div class="flex flex-row w-full justify-between items-center mb-8">
    <h1 class="font-bold mb-0">{{ { key: 'errorLoading' } | i18n }}</h1>
  </div>
  <div class="flex justify-center items-center h-64">
    <div class="text-red-500">{{ { key: 'errorLoading' } | i18n }}</div>
  </div>
} @else {
  @if (data.value(); as doc) {
    <div class="flex flex-col sm:flex-row w-full justify-between items-start sm:items-center mb-8">
      <h1 class="font-bold mb-0 overflow-hidden whitespace-nowrap text-ellipsis w-full">
        {{ { key: doc._bucket, n: 1 } | i18n }} {{ doc.combinedNumber }}
      </h1>
      <div class="mt-4 sm:mt-0 flex-shrink-0">
        @if (doc._bucket !== 'webOrder') {
          <button
            class="block cursor-pointer items-center justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2"
            (click)="api.downloadDocument(doc)"
            target="_blank"
          >
            {{ { key: 'downloadPDF' } | i18n }}
          </button>
        }
      </div>
    </div>

    <div class="rounded-md border border-primary-600 p-4 sm:flex sm:items-center sm:justify-between">
      <div class="grid grid-cols-1 gap-8 w-full text-sm sm:grid-cols-3">
        <div class="flex justify-between sm:block">
          <div class="text-xs text-gray-500 mb-2">
            {{ { key: 'date' } | i18n }}
          </div>
          <div>
            <time>
              {{ { date: doc.date, format: 'dd.LL.yyyy' } | luxon }}
            </time>
          </div>
        </div>
        <div class="flex flex-row justify-between items-center sm:flex-col sm:items-start">
          <div class="text-xs text-gray-500 mb-2">
            {{ { key: 'number' } | i18n }}
          </div>
          <div>{{ doc.combinedNumber }}</div>
        </div>
        @if (doc._bucket === 'invoice') {
          <div class="flex flex-row justify-between items-center sm:flex-col sm:items-start">
            <div class="text-xs text-gray-500 mb-2">
              {{ { key: 'paymentTerm' } | i18n }}
            </div>
            <div>{{ doc.paymentTerm }}</div>
          </div>
        }
        @if (doc.showAmounts) {
          <div class="flex flex-row justify-between items-center sm:flex-col sm:items-start">
            <div class="text-xs text-gray-500 mb-2">{{ { key: 'amountInclVat' } | i18n }}</div>
            <div>
              {{ doc.totalAmountInclVat | bbitFormatPrice }}
            </div>
          </div>
        }
        @if (doc.showAmounts && (doc.openAmount?.amount || 0) > 0 && doc._bucket === 'invoice') {
          <div class="flex flex-row justify-between items-center sm:flex-col sm:items-start">
            <div class="text-xs text-gray-500 mb-2">{{ { key: 'openAmount' } | i18n }}</div>
            <div class="text-red-500">{{ doc.openAmount | bbitFormatPrice }}</div>
          </div>
        }
        @if (doc._bucket === 'deliveryNote' && (doc.shipments?.length || 0) > 0) {
          <div class="flex flex-row justify-between items-center sm:flex-col sm:items-start">
            <div class="text-xs text-gray-500 mb-2">
              {{ { key: 'trackingCode', n: doc.shipments?.length } | i18n }}
            </div>
            <div>
              @for (shipment of doc.shipments; track shipment) {
                <a [href]="'https://www.post.ch/swisspost-tracking?formattedParcelCodes=' + shipment.trackingCode" target="_blank">
                  {{ shipment.trackingCode }}</a
                >
              }
            </div>
          </div>
        }
      </div>
    </div>
    <div class="flex flex-col gap-4 mt-8">
      @for (pos of doc.positions; track pos) {
        <a [routerLink]="['/', 'shop', 'item', pos._slug]">
          <div class="text-sm flex flex-col hover:bg-opacity-10 hover:bg-primary-600 rounded-md p-4 border border-primary-600">
            <div class="mb-4 font-bold">{{ pos.itemNumber }} {{ pos.designation }}</div>

            <div class="grid grid-cols-2 gap-4">
              <div class="flex flex-row justify-between items-center sm:flex-col sm:items-start">
                <div class="text-xs text-gray-500 mb-2">{{ { key: 'quantity' } | i18n }}</div>
                <div>
                  {{ pos.quantity.amount || 0 }}
                </div>
              </div>

              @if (doc.showAmounts) {
                <div class="flex flex-row justify-between items-center sm:flex-col sm:items-start">
                  <div class="text-xs text-gray-500 mb-2">{{ { key: 'price' } | i18n }}</div>
                  <div>
                    <ng-container *ngTemplateOutlet="positionPrice; context: { pos: pos }"></ng-container>
                  </div>
                </div>
              }
            </div>
          </div>
        </a>
      }
    </div>
  }
}

<ng-template #positionPrice let-pos="pos">
  @if (cart.observeIsVatInclusive() | async) {
    <span>{{ pos.priceInclVat | bbitFormatPrice }}</span>
  } @else {
    <span>{{ pos.priceExclVat | bbitFormatPrice }}</span>
  }
</ng-template>
